export default {
  path: '/mall',
  name: 'mall',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '商城管理',
    // keepAlive: false
  },
  children: [
    {
      // 订单管理
      path: 'goodsList',
      name: '商品管理',
      component: () => import('../../views/Mall/GoodsManage'),
      meta: { title: '订单管理', keepAlive: false }
    },
    {
      // 新增商品
      path: 'goodsAdd',
      name: '新增商品',
      component: () => import('../../views/Mall/AddGoods'),
      meta: { title: '新增商品', keepAlive: false }
    },
    {
      // 商品分组
      path: 'goodsGroup',
      name: '商品分组',
      component: () => import('../../views/Mall/GoodsGroup'),
      meta: { title: '商品分组', keepAlive: false }
    },
    {
      // 订单管理
      path: 'orderAdmin',
      name: '订单管理',
      component: () => import('../../views/Mall/OrderAdmin'),
      meta: { title: '订单管理', keepAlive: false }
    },
    {
      // 售后管理
      path: 'afterSaleAdmin',
      name: '售后管理',
      component: () => import('../../views/Mall/AfterSaleAdmin'),
      meta: { title: '售后管理', keepAlive: false }
    },
    {
      // 运费模板管理
      path: 'freightAdmin',
      name: '售后管理',
      component: () => import('../../views/Mall/FreightAdmin'),
      meta: { title: '运费模板管理', keepAlive: false }
    },
    {
      // 交易设置
      path: 'buySet',
      name: '交易设置',
      component: () => import('../../views/Mall/BuySet'),
      meta: { title: '交易设置', keepAlive: false }
    },
  ]
}